<template><!-- <?xml version="1.0" encoding="iso-8859-1"?> -->
<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 461.941 461.941" style="enable-background:new 0 0 461.941 461.941;" xml:space="preserve">
<g>
	<path d="M94.42,143.113c8.82-8.82,23.171-8.82,31.993,0c24.416,24.416,64.145,24.416,88.561,0
		c4.273-4.273,9.954-6.626,15.997-6.626s11.724,2.354,15.997,6.626c24.416,24.416,64.145,24.416,88.561,0
		c4.273-4.273,9.954-6.626,15.997-6.626s11.724,2.354,15.997,6.626c11.828,11.828,27.554,18.342,44.28,18.342
		c16.728,0,32.453-6.514,44.281-18.342c7.811-7.811,7.81-20.474-0.001-28.284c-7.811-7.811-20.474-7.811-28.284,0
		c-4.272,4.273-9.953,6.626-15.996,6.626s-11.724-2.354-15.996-6.625c-11.827-11.828-27.554-18.342-44.28-18.343
		c-0.002,0,0,0-0.001,0c-16.726,0-32.453,6.515-44.281,18.342c-8.82,8.821-23.174,8.819-31.992,0.001
		c-11.827-11.828-27.554-18.342-44.28-18.343c-0.002,0,0,0-0.001,0c-16.726,0-32.453,6.515-44.281,18.342
		c-8.82,8.821-23.174,8.82-31.992,0c-24.417-24.417-64.146-24.417-88.562,0c-8.82,8.82-23.172,8.82-31.994,0
		c-7.811-7.811-20.474-7.811-28.284,0s-7.81,20.474,0.001,28.284C30.274,167.529,70.002,167.529,94.42,143.113z"/>
	<path d="M427.799,216.829c-4.272,4.273-9.953,6.626-15.996,6.626s-11.724-2.354-15.996-6.625
		c-11.827-11.828-27.554-18.342-44.28-18.343c-0.002,0,0,0-0.001,0c-16.726,0-32.453,6.515-44.281,18.342
		c-8.82,8.821-23.174,8.819-31.992,0.001c-11.827-11.828-27.554-18.342-44.28-18.343c-0.002,0,0,0-0.001,0
		c-16.726,0-32.453,6.515-44.281,18.342c-8.82,8.821-23.174,8.82-31.992,0c-24.417-24.417-64.146-24.417-88.562,0
		c-8.82,8.82-23.172,8.82-31.994,0c-7.811-7.811-20.474-7.811-28.284,0s-7.81,20.474,0.001,28.284
		c24.416,24.416,64.144,24.416,88.562,0c8.82-8.82,23.171-8.82,31.993,0c24.416,24.416,64.145,24.416,88.561,0
		c4.273-4.273,9.954-6.626,15.997-6.626s11.724,2.354,15.997,6.626c24.416,24.416,64.145,24.416,88.561,0
		c4.273-4.273,9.954-6.626,15.997-6.626s11.724,2.354,15.997,6.626c11.828,11.828,27.554,18.342,44.28,18.342
		c16.728,0,32.453-6.514,44.281-18.342c7.811-7.811,7.81-20.474-0.001-28.284C448.272,209.018,435.609,209.018,427.799,216.829z"/>
	<path d="M427.799,318.829c-4.272,4.273-9.953,6.626-15.996,6.626s-11.724-2.354-15.996-6.625
		c-11.827-11.828-27.554-18.342-44.28-18.343c-0.002,0,0,0-0.001,0c-16.726,0-32.453,6.515-44.281,18.342
		c-8.82,8.821-23.174,8.819-31.992,0.001c-11.827-11.828-27.554-18.342-44.28-18.343c-0.002,0,0,0-0.001,0
		c-16.726,0-32.453,6.515-44.281,18.342c-8.82,8.82-23.174,8.821-31.992,0c-24.417-24.417-64.146-24.417-88.562,0
		c-8.82,8.82-23.172,8.82-31.994,0c-7.811-7.811-20.474-7.811-28.284,0s-7.81,20.474,0.001,28.284
		c24.416,24.416,64.144,24.416,88.562,0c8.82-8.82,23.171-8.82,31.993,0c24.416,24.416,64.145,24.416,88.561,0
		c4.273-4.273,9.954-6.626,15.997-6.626s11.724,2.354,15.997,6.626c24.416,24.416,64.145,24.416,88.561,0
		c4.273-4.273,9.954-6.626,15.997-6.626s11.724,2.354,15.997,6.626c11.828,11.828,27.554,18.342,44.28,18.342
		c16.728,0,32.453-6.514,44.281-18.342c7.811-7.811,7.81-20.474-0.001-28.284C448.272,311.018,435.609,311.018,427.799,318.829z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>